import { ComponentProps } from 'react';

import { collectImageComponentParams } from 'strapi/component/shared/collector';
import { ReactComponentType } from 'strapi/component/types';
import { AiWritingToolParentStrapiPage } from 'strapi/page/aiWritingToolParentPage';
import { MockupParentStrapiPage } from 'strapi/page/mockupParentPage';
import { PageType, PageTypes } from 'strapi/page/types';
import { ReactComponentBuildResponse } from 'strapi/types';

import { CategoryList } from '../categoryList';

export const collectChildrenListParams = (
  pageType: PageType,
  page: PageTypes
): ReactComponentBuildResponse<typeof CategoryList> | undefined => {
  if (!('childrenList' in page) || !page.childrenList) {
    return undefined;
  }

  let items: ComponentProps<typeof CategoryList>['categories'][0]['items'] = [];

  if (pageType === PageType.MockupParentPage) {
    const mockupParentPage = page as MockupParentStrapiPage;
    items = mockupParentPage.mockup_child_pages
      ?.filter((x) => !!x?.path)
      .map((x) => ({
        title: x.descriptiveName ?? x.slug,
        url: x.path,
        image: collectImageComponentParams(x.cover)!,
      }));
  }

  if (pageType === PageType.AiWritingToolParentPage) {
    const aiWritingToolParentPage = page as AiWritingToolParentStrapiPage;
    items = aiWritingToolParentPage.ai_writing_child_pages
      ?.filter((x) => !!x?.path)
      .map((x) => ({
        title: x.descriptiveName ?? x.slug,
        url: x.path,
        image: collectImageComponentParams(x.cover)!,
      }));
  }

  if (!items || items?.length === 0) {
    return undefined;
  }

  return {
    component: ReactComponentType.CategoryList,
    props: {
      withNavigation: false,
      categories: [
        {
          name: page.childrenList.title,
          description: page.childrenList.description,
          items: items,
        },
      ],
      backgroundColor: page.childrenList.backgroundColor,
    },
  };
};
